module.exports = __webpack_public_path__ + "img/book.f3b1c653.png";